// Code generated by OpenAPI Generator (https://openapi-generator.tech), manual changes will be lost - read more on https://github.com/flapjackhq/sdk-automation. DO NOT EDIT.

import { createXhrRequester } from '@flapjack-search/requester-browser-xhr';
import {
  IndexNotFoundError,
  IndicesInSameAppError,
  IndexAlreadyExistsError,
  createNullLogger,
  createMemoryCache,
  createFallbackableCache,
  createBrowserLocalStorageCache,
  createNullCache,
  serializeQueryParameters
} from '@flapjack-search/client-common';

import type { RequestOptions, ClientOptions } from '@flapjack-search/client-common';

import { createSearchClient, apiClientVersion } from '../src/searchClient';


export {
  apiClientVersion,
} from '../src/searchClient';

export * from '../model';

import type { 
  AccountCopyIndexOptions,
  BrowseResponse,
  GenerateSecuredApiKeyOptions,
  GetSecuredApiKeyRemainingValidityOptions,
  SearchClientNodeHelpers,
  SearchRulesResponse,
  SearchSynonymsResponse,
  UpdatedAtResponse,
} from '../model';

export function searchClient(
  appId: string,
  apiKey: string,
  options?: ClientOptions | undefined
): SearchClient {
  if (!appId || typeof appId !== 'string') {
    throw new Error("`appId` is missing.");
  }
  
  if (!apiKey || typeof apiKey !== 'string') {
    throw new Error("`apiKey` is missing.");
  }
  
  return createSearchClient({
    appId,
    apiKey,
    timeouts: {
      connect: 1000,
      read: 2000,
      write: 30000,
    },
    logger: createNullLogger(),
    requester: createXhrRequester(),
    flapjackAgents: [{ segment: 'Browser' }],
    authMode: 'WithinQueryParameters',
    responsesCache: createMemoryCache(),
    requestsCache: createMemoryCache({ serializable: false }),
    hostsCache: createFallbackableCache({
      caches: [
        createBrowserLocalStorageCache({ key: `${apiClientVersion}-${appId}` }),
        createMemoryCache(),
      ],
    }),
    ...options,
  });
}

export type SearchClient = ReturnType<typeof createSearchClient>;
